import { useStepper } from '@/features/v2/lib/stepper';
import ACPolicy from '@/features/v2/vehicle-damage/components/documents/ACPolicy';
import DamagePhotos from '@/features/v2/vehicle-damage/components/documents/DamagePhotos';
import InsurersDecision from '@/features/v2/vehicle-damage/components/documents/InsurersDecision';
import InsurersEstimate from '@/features/v2/vehicle-damage/components/documents/InsurersEstimate';
import InvoicesReceiptsOrOtherDocuments from '@/features/v2/vehicle-damage/components/documents/InvoicesReceiptsOrOtherDocuments';
import RegistrationCard from '@/features/v2/vehicle-damage/components/documents/RegistrationCard';
import SalesContract from '@/features/v2/vehicle-damage/components/documents/SalesContract';
import { VehicleDamageSchema } from '@/features/v2/vehicle-damage/stepsSchema';

import { useFormContext } from 'react-hook-form';

export const PartACUploader = () => {
  const { step, innerStep } = useStepper();

  const { watch } = useFormContext();
  const additionalSteps = VehicleDamageSchema[step]?.lastStep?.(watch()) ?? {};

  const { additionalStep, secondAdditionalStep } = additionalSteps;

  const plusAdditional = additionalStep ? 1 : 0;

  return (
    <>
      {innerStep === 0 && <InsurersEstimate />}
      {innerStep === 1 && additionalStep && <SalesContract />}
      {innerStep === 1 + plusAdditional && <ACPolicy />}
      {innerStep === 2 + plusAdditional && <InsurersDecision />}
      {innerStep === 3 + plusAdditional && <RegistrationCard />}
      {innerStep === 4 + plusAdditional && <DamagePhotos />}
      {innerStep === 5 + plusAdditional && secondAdditionalStep && (
        <InvoicesReceiptsOrOtherDocuments />
      )}
    </>
  );
};
